import { render } from "./EnlargeIcon.vue?vue&type=template&id=c2df8e96"
import script from "./EnlargeIcon.vue?vue&type=script&lang=js"
export * from "./EnlargeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__